module.exports = __webpack_public_path__ + "static/media/registrarventa.a90fdbcd.svg";